import { config } from 'Shared/Services/environment.service';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
/* tslint:disable */
let autoComplete: any;

const loadScript = (url: string, callback: () => void) => {
  const script: any = document.createElement('script');
  script.type = 'text/javascript';

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};

function handleScriptLoad(
  updateQuery: (query: string) => void,
  autoCompleteRef: any
) {
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    { componentRestrictions: { country: 'it' } }
  );
  autoComplete.setFields(['address_components', 'formatted_address']);
  autoComplete.addListener('place_changed', () =>
    handlePlaceSelect(updateQuery)
  );
}

async function handlePlaceSelect(updateQuery: (query: string) => void) {
  const addressObject = autoComplete.getPlace();
  const query = addressObject.formatted_address;
  updateQuery(query);
}

interface SearchLocationInputProps {
  onSelected: (query: string) => void;
  isExternal?: boolean;
}

export const SearchLocationInput: React.FC<SearchLocationInputProps> = ({
  onSelected,
  isExternal = false,
}) => {
  const [query, setQuery] = useState('');
  const autoCompleteRef = useRef(null);
  const { t } = useTranslation(['valutatore']);
  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${config(
        'NX_NEXT_PUBLIC_GOOGLE_MAPS_KEY'
      )}&libraries=places`,
      () => handleScriptLoad(setQuery, autoCompleteRef)
    );
  }, []);

  return (
    <div
      className="search_location"
      style={isExternal ? { width: '100%' } : {}}
    >
      <input
        ref={autoCompleteRef}
        onChange={(event) => setQuery(event.target.value)}
        placeholder={t('landing.placeholder')}
        value={query}
        className="search_location__input"
      />
      <button
        disabled={!query}
        onClick={() => onSelected(query)}
        className="search_location__button"
      >
        <span>{t('landing.evaluate')}</span>
      </button>
    </div>
  );
};
